export default {
  methods: {
    format (num) { //千分位转换
      var reg=/\d{1,3}(?=(\d{3})+$)/g;   
      return (num + '').replace(reg, '$&,');  
    },
    render_overview(data) {
      // console.log(data);
      data.monthVo.forEach(v=>{  //销量千分位转换
        if(v.newProAndSale) {
          // v.saleNum = this.format(v.saleNum)
          v.newProAndSale.forEach(k=>{
            k.saleNum = this.format(k.saleNum)
          })
        }
      })
      let option = {
        // title: {
        //   text: '今年产品上新概览',
        //   top: 10
        // },
          subtitle: {
              text: `截止到${new Date().getMonth + 1}月，上新数${data.newProductTotal}}共计销量${data.saleNumTotal}`,
              top: 0,
              right: 0,
              textStyle: {
                fontSize: 12,
                color: '#777',
                fontWeight: 'normal'
              }
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              },
              enterable: true,
              hideDelay: 300,
              formatter: params => {
                const arr = data.monthVo[params[0].dataIndex].newProAndSale;
                let str;
                str = `${data.monthVo[params[0].dataIndex].month}月<br/>`
                arr.forEach(item=>{
                  str += `${item.categoryName}上新${item.newProductCount||0}种销量${item.saleNum||0}<br/>`
                })
                console.log(data);
                // let all = `总销量${data.monthVo[params[0].dataIndex].saleNum}<br/>`
                // str += all
                return `<div style="height: 300px; overflow: scroll;"><div class="infinity-scroll">${str}</div></div>`
              },
              position: [10, 10],
              // alwaysShowContent: true,
              // className: 'tooltips-scroll',
              triggerOn: 'click'
          },
          legend: {
              data: ['销量', '产品数'],
              top: 65,
              textStyle: {
                color: '#fff',
                fontFamily: 'PingFangSC'
              }
          },
          grid: {
            left: 80,
            bottom: 30,
            right: 50,
            top: 120
          },
          graphic: [{
            type: 'group',
            id: 'textGroup2',
            left: 20,
            bottom: 10,
            position: [10, 0],
            children: [
              {
                type: 'text',
                z: 100,
                top: 'middle',
                left: 100,
                style: {
                  text: '付款时间',
                  textVerticalAlign: 'middle',
                  fontFamily: 'PingFangSC',
                  fill: 'rgba(255,255,255,0.9)'
                }
              }
            ]
          }],
          xAxis: [
              {
                  type: 'category',
                  data: data.monthVo.map(v=>v.month),
                  axisPointer: {
                      type: 'shadow',
                      label:{
                        show: false
                      }
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgba(255,255,255,0.9)',
                    interval: 0,
                    formatter: value =>{
                      if(value.length > 4) {
                        return String(value).substring(0,4)+'...'
                      }else{
                        return value+'月'
                      }
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      color: 'rgba(255,255,255,0.9)'
                    }
                  }
              }
          ],
          yAxis: [
              {    
                  name: '销量',
                  type: 'value',
                  axisPointer: {
                    type: 'none',
                    label: {
                      show: false
                    }
                  },
                  minInterval: 1,
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  },
                  splitLine: { show: false }
              },
              {
                  name: '产品数',
                  type: 'value',
                  axisPointer: {
                    type: 'none',
                    label: {
                      show: false
                    }
                  },
                  minInterval: 1,
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  },
                  splitLine: { show: false }
              }
          ],
          series: [
              {   
                  name: '销量',
                  type: 'line',
                  yAxisIndex: 0,
                  data: data.monthVo.map(v=>v.saleNum),
                  itemStyle: {
                    color: 'rgb(250,137,0)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  label: {
                    show: true,
                    position: 'top',
                    color: '#e2e2e2',
                    fontFamily: 'PingFangSC'
                  },
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#ffffff',
                      borderColor: '#00A6ED',
                      borderWidth: 0
                    }
                  },
                  selectedMode: true
              },
              {
                  name: '产品数',
                  type: 'bar',
                  yAxisIndex: 1,
                  data: data.monthVo.map(v=>v.newProduct),
                  itemStyle: {
                    color: 'rgb(11,183,142)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  label: {
                    show: true,
                    position: 'top',
                    color: '#e2e2e2',
                    fontFamily: 'PingFangSC'
                  },
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#00A6ED',
                      borderColor: '#00A6ED'
                    }
                  },
                  selectedMode: true
              }
          ],
          animationDelay: function(idx) {
            return 50*idx
          }
      };
      let $instance = this.$echarts.init(this.$refs['updateoverview']);
      $instance.setOption(option);
      // $instance.on('click',params => {
      //     console.log(params);
      //     this.$refs['classify'].handleCategoryChange(params.name)
      //     $instance.dispatchAction({
      //       type: 'select',
      //       seriesIndex: params.seriesIndex ? 0 : 1,
      //       dataIndex: params.dataIndex
      //     });
      // });
    }
  }
}